import { render, staticRenderFns } from "./WaiterLabelSettingTable.vue?vue&type=template&id=47d84431&scoped=true&lang=pug"
import script from "./WaiterLabelSettingTable.vue?vue&type=script&lang=ts"
export * from "./WaiterLabelSettingTable.vue?vue&type=script&lang=ts"
import style0 from "./WaiterLabelSettingTable.vue?vue&type=style&index=0&id=47d84431&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d84431",
  null
  
)

export default component.exports